import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/offersMarketingFlyout/GET';

export const OFFERS_MARKETING_FLYOUT_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const OFFERS_MARKETING_FLYOUT_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
